"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';

import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import epccban from '../images/lightningcategory/epcc_page_banner.jpg';
import epccban_360 from '../images/lightningcategory/epcc_page_banner_360.jpg';
import epccban_tab from '../images/lightningcategory/epcc_page_banner_tab.jpg';
import epccban_2x from  '../images/lightningcategory/epcc_page_banner@2x.jpg';
import Epccdetailscontent from '../components/Epccdetailscontent';
const EPCCPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok EarthPit Chamber Cover (EPCC) — HDPE, UV-stabilised" apostropheBefore="" apostropheAfter="" ban1x={epccban} ban2x={epccban_2x} ban360={epccban_360} bantab={epccban_tab} />
           <ProductsubMenu/>
          
           <Epccdetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default EPCCPage
 
